export default __webpack_public_path__ + "static/media/trushti.f8b7903e.jpeg";